<template>
  <div class="app-container">
    <Container
      :title="t('route.paymentSlipDetails')"
      :hasLine="true"
    >
      <template #main>
        <el-form
          :label-width="labelWidth"
          ref="cFormRef"
          label-position="left"
          style="margin-left:15%; font-size: 14px;"
        >
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('company.companyCode')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.companyCode }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('pay.payee')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.payee }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('pay.PaymentBankNO')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.companyBankAccount }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('pay.ReceivingBankNO')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.bankAccount }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('pay.PaymentBankNumber')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.companyBankCode }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('pay.ReceivingBankNumber')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.bankCode }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('pay.PaymentBankName')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.companyBankName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="t('pay.ReceivingBankName')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.bankName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('pay.PaymentAmount')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ formatThousands(detailData.amount) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('pay.currency')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.currency }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('pay.paymentDate')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ paymentDateFormat(detailData.paymentDate) }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="4">
            <el-col :span="8">
              <el-form-item
                :label="t('pay.purpose')"
                label-width="180px"
                style="text-align: left;"
              >
                <span>{{ detailData.purpose }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </template>
    </Container>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive, toRefs } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import { formatDate, formatThousands } from '@/utils'
import { getSlipBufferDetail } from '@/apis/paymentSlip/paymentSlip'
import { PaymentSlipBufferDetailModel } from '@/model/paymentSlip/paymentSlipModel'
import Container from '@/components/form/container/Container.vue'

export default defineComponent({
  name: 'PaymentSlipBufferDetail',
  methods: { formatThousands },
  props: {
    inputData: {
      type: Object,
      required: true,
      default: null
    },
    labelWidth: {
      type: String,
      default: '680px'
    }
  },
  components: {
    Container
  },
  setup() {
    const { t } = useI18n()
    const id = useRoute().params.id.toString()
    const dataMap = reactive({
      detailData: {} as PaymentSlipBufferDetailModel | null,
      paymentDate: '',
      listLoading: true,
      async getData() {
        dataMap.listLoading = true
        const data = await getSlipBufferDetail(id)
        if (data && data.data) {
          dataMap.detailData = data.data
        }
        // Just to simulate the time of the request
        setTimeout(() => {
          dataMap.listLoading = false
        }, 0.5 * 1000)
      },
      paymentDateFormat(paymentDate: Date): string {
        return formatDate(paymentDate, 'yyyy-MM-dd')
      }
    })
    onMounted(() => {
      dataMap.getData()
    })
    return {
      t,
      ...toRefs(dataMap)
    }
  }
})
</script>

<style scoped lang="scss">

</style>
